<template>
  <div class="container">
    <nyTit1 pathUrl="/xiaofeiTradeData" />
    <Tit title="全县电商直播活动数据系统" />
    <div class="content">
      <!-- 左侧 -->
      <div class="leftBox">
        <!-- 左侧-左侧 -->
        <div class="left_left">
          <div class="left_l_Box1">
<!--            <div class="title"><div class="titleBg">电商引领  创新驱动  三产融合  上蔡样板</div></div>-->
            <div class="boxContent1">
              <div class="boxContent1Left">
                <!-- 上部份的左边 -->
                <div class="left_r_contentB">
<!--                  <div-->
<!--                    class="leftcontent1BItem"-->
<!--                    v-for="(item, index) in leftRightData1"-->
<!--                    :key="index"-->
<!--                  >-->
<!--                    <img :src="item.icon" />-->
<!--                    <div class="itemRight">-->
<!--                      <span>{{ item.value }}</span>-->
<!--                    </div>-->
<!--                    <div class="right_txt">-->
<!--                      <span>{{ item.txt1 }}</span>-->
<!--                      <span>{{ item.txt2 }}</span>-->
<!--                      <span>{{ item.txt3 }}</span>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="left_r_contentB_top">


                    <div class="contentB_top_nr"  v-for="(item, index) in dszhiboData" :key="index">
                      <img src="../assets/img/xaiofei/data/new/sj.png">
                      <span>{{item.name}}</span>
                    </div>



                  </div>
                  <div class="left_r_contentB_down">
                    <div class="contentB_down_img">
                      <img src="../assets/img/xaiofei/data/new/2023.png">
                      <span>2025</span>
                    </div>
                    <div class="ontentB_down_nr">
                      <span>电商交易总额46.0亿元</span>
                      <span>电商企业413家</span>
                      <span>从业人数1210人</span>


                    </div>



                  </div>
                </div>
                <!-- 上部份的左边 -->
                <!-- 上部份的右边边 -->
                <div class="left_top_youbian">
                  <!-- <leftLine /> -->
                  <leftBar />
                </div>

                <!-- 上部份的右边边 -->
              </div>
            </div>
          </div>
        </div>
        <!-- 左侧-右侧 -->
        <div class="left_right">
          <div class="left_r_Box2">

            <div  class="boxContent1Rights">
              <div class="boxContent1Rights_nr" v-for="(item, index) in dszhiboData1" :key="index">
                <img src="../assets/img/xaiofei/data/new/dz.png">
                <span>{{item.name}}</span>
              </div>



            </div>
            <!-- 旋转的魔方结束-->
          </div>
          <!-- 下部分左边开始 -->
          <div class="left_r_Box1">
            <div class="titledow"><div class="titleBg">直播电商</div></div>
            <div class="left_r_contentA">
              <div
                class="zhu_zhuang_tu"
                v-for="(item, index) in zhiboData1"
                :key="index"
              >
                <span class="sapn_top">{{ item.name }}</span>
                <span class="sapn_down">{{ item.txt1 }}</span>
<!--                <span class="sapn_down1">{{ item.txt2 }}{{ item.txt3 }}</span>-->
                <!-- <span class="sapn_down2"></span> -->

                <img :src="item.icon" />
              </div>
            </div>
          </div>
          <!-- 下部分左边结束 -->

          <!-- 下部分中间开始 -->
          <div class="left_r_Box1">
            <div class="titledow"><div class="titleBg">传统电商</div></div>
            <div class="left_r_contentA">
              <div
                class="zhu_zhuang_tu"
                v-for="(item, index) in zhiboData2"
                :key="index"
              >
                <span class="sapn_top">{{ item.name }}</span>
                <span class="sapn_down">{{ item.txt1 }}</span>
<!--                <span class="sapn_down1">{{ item.txt2 }}{{ item.txt3 }}</span>-->
                <!-- <span class="sapn_down2"></span> -->
                <img :src="item.icon" />
              </div>
            </div>
          </div>
          <!-- 下部分中间结束 -->

          <!-- 下部分右边开始 -->
<!--          <div class="left_r_Box2">-->
<!--            &lt;!&ndash; 旋转的魔方开始 &ndash;&gt;-->

<!--            <div ref="canvasContainer" class="boxContent1Right"></div>-->
<!--            &lt;!&ndash; 旋转的魔方结束&ndash;&gt;-->
<!--          </div>-->
          <!-- 下部分右边结束 -->
        </div>
      </div>
      <!-- 大右边开始 -->
      <div class="rightBox">
        <!-- 右一左 一-->
        <!-- 右边第一个开始 -->
        <div class="right_right">
          <!-- 右-右 直播产品分布-->
          <div class="center_videoBox">
            <div class="center_video_item" v-for="(item,index) in center_data" :key="index"  @click="videoClick(index,item.type)"><img :src="item.img"/> </div>
          </div>
          <div class="leftBox2">
            <div class="title"><div class="titleBg">优秀电商企业</div></div>

            <div class="leftContent">
              <dv-scroll-board
                :config="config"
                style="width: 100%; height: 100%"
              />
            </div>
          </div>
          <!-- 右三  产品带货列表-->

        </div>
        <!-- 右边第一个结束 -->

        <!-- 右边第二开始 -->
        <div class="right_left">
          <!-- 电商主播 -->
          <div class="rightBox1">
            <div class="title"><div class="titleBg">网红达人</div></div>
            <div class="rightcontent2">
              <zhuboItem :list="right_left_data1" />
            </div>
          </div>

          <div class="leftBox3">
            <div class="title"><div class="titleBg">产品销售信息</div></div>
            <div class="leftBox1">
              <div class="leftContent1">
                <div  class="leftContent1_item"  v-for="(item, index) in leftData1"  :key="index">
                  <span class="leftContent1_item_name">{{ item.name }}</span><span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
                </div>
              </div>
            </div>
            <div class="leftBox2">
              <div class="title1">2025年度产品销售情况</div>
              <div class="echartBox"><leftPie /></div>
            </div>
            <div class="leftBox33" >
              <div class="leftBox33_nr" v-for="(item, index) in ddjyData"  :key="index"> {{item.name}}</div>
            </div>
          </div>

          <!-- 主播订单量 -->
<!--          <div class="rightBox2">-->
<!--            <el-carousel :interval="5000" arrow="never" indicator-position="outside">-->
<!--              <el-carousel-item v-for="(item, index) in rightImg" :key="index">-->
<!--                <img :src="item.imageUrl" alt="carousel-image" class="carousel-image">-->
<!--              </el-carousel-item>-->
<!--            </el-carousel>-->
<!--          </div>-->
        </div>

        <!-- 右边第二结束 -->
      </div>
      <!--中间直播间开始  -->
      <div class="center">
<!--        <div-->
<!--          class="center_zho_bo"-->
<!--          v-for="(item, index) in center_data"-->
<!--          :key="index"-->
<!--          @click="videoClick(index,item.type)"-->
<!--        >-->
<!--        <img :src="item.img" />-->
<!--          <div class="center_zho_bo_baio_ti">{{ item.name }}</div>-->
<!--        </div>-->
        <div class="center_left">
          <div class="grid-item grid-item-1">直播间浏览量</div>
          <div class="grid-item grid-item-2"><LiveStats v-bind="liveStatsConfig" /></div>
          <div class="grid-item grid-item-3">
            <LiveTrend v-bind="liveTrendConfig" />
          </div>
          <div class="grid-item grid-item-4">
            <LiveTrend v-bind="interactionTrendConfig" />
          </div>
        </div>
        <div class="center_mi">
          <div class="center_mi_top">
            <div class="img1 img">
              <vue3VideoPlay
                id="video"
                ref="videoRef"
                width="100%"
                height="100%"
                title="视频监控"
                :src="options.src"
                :type="options.type"
                :autoPlay="false"
                :muted="true"
                :control="false"
                :loop="true"
                @loadedmetadata="onLoadedMetadata"
              />

              <div class="jian_kong_fc">巨型一号直播间1</div>
            </div>

          </div>
          <div class="center_mi_down">
            <div class="img1 img">
              <!-- img src="../assets/img/sanchan1/zz.jpg" /> -->
              <vue3VideoPlay
                id="video"
                ref="videoRef"
                width="100%"
                height="100%"
                title="视频监控"
                :src="options3.src"
                :type="options3.type"
                :autoPlay="false"
                :muted="true"
                :control="false"
                :loop="true"
                @loadedmetadata="onLoadedMetadata"
              />
              <div class="jian_kong_fc"><span>巨型一号直播间2</span></div>
            </div>
          </div>

        </div>
        <div class="center_right">
          <div class="center_right_top" >
            <div class="img1 img">
              <vue3VideoPlay
                id="video"
                ref="videoRef"
                width="100%"
                height="100%"
                title="视频监控"
                :src="options2.src"
                :type="options2.type"
                :autoPlay="false"
                :muted="true"
                :control="false"
                @loadedmetadata="onLoadedMetadata"
              />
              <div class="jian_kong_fc">巨型一号种植基地</div>
            </div>
          </div>
          <div class="center_right_down" >
            <div class="img1 img">
              <vue3VideoPlay
                id="video"
                ref="videoRef"
                width="100%"
                height="100%"
                title="视频监控"
                :src="options1.src"
                :type="options1.type"
                :autoPlay="false"
                :muted="true"
                :control="false"
                @loadedmetadata="onLoadedMetadata"
              />
              <div class="jian_kong_fc">巨型一号加工基地</div>
            </div>
          </div>
        </div>

      </div>
      <!--中间直播间结束  -->
      <!-- 右侧 -->


    </div>
  </div>
  <popBg v-if="popShow" :title="popShow?center_data[curVideoIndex].name:''" :popShow="popShow" @hiddlen="popHiddlen"
         :code="center_data[curVideoIndex].code"
  >

    <div style=" width: 100%;height: 100%" v-if="videotype===1">
      <vue3VideoPlay id="video" width="100%" height="100%" :title="center_data[curVideoIndex].name" :src="center_data[curVideoIndex].options.src" :type="center_data[curVideoIndex].options.type" :autoPlay="true" />
    </div>
    <div style=" width: 100%;height: 100%" v-else>
      <iframe v-if="AccessToken!=''"
              :src="center_data[curVideoIndex].options.src+AccessToken"
              width="100%"
              height="100%"
              id="ysOpenDevice"
              allowfullscreen
      >
      </iframe>
    </div>
  </popBg>
<!--  <footer1 />-->
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";
import { useRouter } from "vue-router";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
  inject
} from "vue";
//
import waterimg from "@/assets/img/xaiofei/data1/mf.png";
// const canvasContainer = ref(null);
let renderer, scene, camera, textureLoader, mesh;
let rotationSpeedX = 0.01;
let rotationSpeedY = 0.015;
let rotationSpeedZ = 0.03;

// import leftPie from "../components/xiaofeiData/leftPie.vue"
import leftLine from "../components/xiaofeiData/left_r_line.vue";
import rightRBar from "../components/xiaofeiData/right_r_bar.vue";
import leftBar from "../components/xiaofeiData/left_bar.vue";
// import rightBar from "../components/xiaofeiData/rightBar.vue"
import centerRadar from "../components/xaiofei/centerRadar3";
// import rightLine from "../components/xiaofeiData/rightLine.vue"
import LeftLBar from "../components/xiaofeiData/left_l_bar";
import zhuboItem from "../components/xiaofeiData/zhuboItem";
import footer1 from "../components/footer.vue";
import popBg from "../components/popBg.vue";
import nyTit1 from "@/components/nyTit1.vue";
import leftPie from "@/components/xiaofeiData/left_pie";
import LiveStats from "@/components/xiaofeiData/LiveStats";
import LiveTrend from "@/components/xiaofeiData/LiveTrend";
import Tit from "@/components/Tit.vue";
export default {
  name: "Home",
  setup() {
    const { appContext } = getCurrentInstance();
    const timer = ref(null);
    const router = useRouter();
    const formatHour = (date) => {
      const hour = `${date.getHours()}`.padStart(2, "0");
      return `${hour}:00`;
    };
    const recentHourSlots = Array.from({ length: 6 }, (_, index) => {
      const date = new Date();
      date.setHours(date.getHours() - (5 - index), 0, 0, 0);
      return {
        label: formatHour(date),
        hour: date.getHours(),
      };
    });
    const recentHourLabels = recentHourSlots.map((item) => item.label);
    const influencerFansWan = [562.3, 482.3, 189.4, 155.3, 31.2, 28.5, 27.3, 29.3, 24.3, 17.8];
    const totalFansWan = influencerFansWan.reduce((sum, item) => sum + item, 0);
    const getHourFactor = (hour) => {
      const factors = [0.24, 0.2, 0.18, 0.16, 0.18, 0.24, 0.34, 0.46, 0.6, 0.72, 0.78, 0.84, 0.92, 0.86, 0.8, 0.88, 0.98, 1.12, 1.34, 1.58, 1.72, 1.62, 1.34, 0.86];
      return factors[hour] || 0.8;
    };
    const formatNumber = (value) => Math.round(value).toLocaleString("zh-CN");
    const formatDuration = (minutes) => {
      const totalSeconds = Math.round(minutes * 60);
      const hour = `${Math.floor(totalSeconds / 3600)}`.padStart(2, "0");
      const minute = `${Math.floor((totalSeconds % 3600) / 60)}`.padStart(2, "0");
      const second = `${totalSeconds % 60}`.padStart(2, "0");
      return `${hour}:${minute}:${second}`;
    };
    const buildTrendSeries = () => {
      const online = [];
      const enter = [];
      const leave = [];
      const comment = [];
      const like = [];
      const view = [];
      const duration = [];

      recentHourSlots.forEach((slot, index) => {
        const factor = getHourFactor(slot.hour);
        const stepFactor = 0.92 + index * 0.035;
        const fansBase = totalFansWan * factor;
        const onlineValue = Math.round((2600 + fansBase * 2.55) * stepFactor);
        const enterValue = Math.round(onlineValue * (1.18 + factor * 0.08));
        const leaveValue = Math.round(onlineValue * (0.42 + (1.8 - factor) * 0.08));
        const commentValue = Math.round(onlineValue * (0.56 + factor * 0.12));
        const likeValue = Math.round(commentValue * (5.8 + factor * 1.2));
        const viewValue = Math.round(enterValue * (8.6 + factor * 2.4));
        const durationValue = 13.5 + factor * 5.2 + index * 0.35;

        online.push(onlineValue);
        enter.push(enterValue);
        leave.push(leaveValue);
        comment.push(commentValue);
        like.push(likeValue);
        view.push(viewValue);
        duration.push(durationValue);
      });

      const latestIndex = online.length - 1;
      const latestOnline = online[latestIndex];
      const latestComments = comment[latestIndex];
      const latestLikes = like[latestIndex];
      const totalViews = view.reduce((sum, item) => sum + item, 0);
      const averageDuration = duration.reduce((sum, item) => sum + item, 0) / duration.length;
      const heat = Math.round(latestOnline * 0.72 + latestComments * 0.38 + latestLikes * 0.05);

      return {
        online,
        enter,
        leave,
        comment,
        totalViews,
        averageDuration,
        heat,
        latestOnline,
        latestLikes,
      };
    };
    const trendSeries = buildTrendSeries();
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      videotype:1,
      currentTime: "",
      isShow: false,
      liveStatsConfig: {
        totalViews: formatNumber(trendSeries.totalViews),
        metrics: [
          { label: "实时在线人数", value: formatNumber(trendSeries.latestOnline) },
          { label: "人均观看时长", value: formatDuration(trendSeries.averageDuration) },
          { label: "直播间热度", value: formatNumber(trendSeries.heat) },
          { label: "点赞数", value: formatNumber(trendSeries.latestLikes) },
        ],
      },
      liveTrendConfig: {
        title: "实时趋势",
        metricTitle: "",
        rangeText: "",
        showHelp: false,
        xAxisData: recentHourLabels,
        yAxis: {
          min: 0,
          max: 15000,
          interval: 3000,
        },
        seriesData: [
          {
            name: "在线人数",
            color: "#25dfff",
            data: trendSeries.online,
            lineWidth: 3,
          },
          {
            name: "进场人数",
            color: "#2478ff",
            data: trendSeries.enter,
            lineWidth: 3,
          },
          {
            name: "离场人数",
            color: "#c7d0e4",
            lineWidth: 3,
            data: trendSeries.leave,
          },
        ],
      },
      interactionTrendConfig: {
        title: "互动趋势",
        metricTitle: "",
        rangeText: "",
        showHelp: false,
        xAxisData: recentHourLabels,
        yAxis: {
          min: 0,
          max: 15000,
          interval: 3000,
        },
        seriesData: [
          {
            name: "评论数",
            color: "#f3ca28",
            shadowColor: "rgba(243, 202, 40, 0.75)",
            areaStartAlpha: 0.28,
            areaMiddleAlpha: 0.12,
            data: trendSeries.comment,
            lineWidth: 3,
          },
        ],
      },
      config: {
        header: [
          '<span style="color:#00FFFF;">企业名称</span>',
          '<span style="color:#00FFFF;">经营类目</span>',
          '<span style="color:#00FFFF;">电商类型</span>',
          '<span style="color:#00FFFF;">日单量</span>',
          '<span style="color:#00FFFF;">2026销售总额</span>',
        ],
        data: [
          ["太阳仓", "农特产品", "供应链平台", " 300-500单", " 240万"],
          ["巨型一号", "美妆护肤", "直播电商", "100-300单", "3229.8万"],
          ["囧驿食品", "自热小火锅", "直播电商", "1000-5000单", "2377.5万"],
          ["百汇通", "农产品、百货", "直播电商", "300-1200单", "717.5万"],
          ["古蔡铁锅", "厨房用品", "直播电商", "200-500单", "607.1万"],
          ["张坤猪蹄", "食品卤味", "直播电商", "50-300单", "697.3"],
          ["状元红酒", "酒水", "直播电商", "50-300单", "1355"],
          ["登亚农产品", "农产品", "直播电商", "300-1000单", "724.9"],
          ["茵速体育", "体育用品", "传统电商", "1000-3000单", "1122.5"],
          ["江坤卫生用品", "卫生用品", "传统电商", "5000-8000单", "3114.8"],
        ],
        headerBGC: "",
        oddRowBGC: "#04232C",
        evenRowBGC: "",
        // index: true,
        columnWidth: [200],
        align: ["center", "center", "center", "center"],
        rowNum: 7,
      },
      leftData1: [
        { name: "2023年电商销售总额", value: 2900, unit: "万" },
        { name: "2024年电商销售总额", value: 3010, unit: "万" },
        { name: "2025年电商销售总额", value: 3229.8, unit: "万" },
      ],
      leftData:[
        {
          title:"打造全省领先的县级电商基地",
          list:["专业团队  ： 山东易谷商业运营管理有限公司","完备设施   ：13个标准直播间","优惠政策  ：租金减免 税收优惠 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;规模扶持 示范激励"],
          icon:require('../assets/img/sanchan1/ds.png')
        },
        {
          title:"筛选优质企业入驻园区免费孵化陪跑",
          list:["孵化成功的企业搬离园区，扩大规模","筛选孵化新一批企业"],
          icon:require('../assets/img/sanchan1/yq.png')
        },
        {
          title:"推动实现孵化、发展、孵化长期循环",
          list:["已成功孵化电商企业11家，加工企业5家","正在孵化电商企业12家，加工企业7家"],
          icon:require('../assets/img/sanchan1/ds.png')
        }
      ],
      options: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/sgs.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      options1: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/2jiagong.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      options2: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/3zhongzhi02.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      options3: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/777.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      ddjyData: [
        {
          name: "带动加工业产值5000万元",

        },
        {
          name: "带动丝瓜种植面积1650亩",

        },

      ],
      dszhiboData: [
        {
          name: "2015年被确定为“省级电子商务示范县”",

        },
        {
          name: "2017年被确定为“河南省电子商务进农村综合示范县”",

        },
        {
          name: "2019年被确定为“国家级电子商务进农村综合示范县”",

        },
      ],
      dszhiboData1: [
        {
          name: "省级认定备案电子商务企业34家",

        },
        {
          name: "省级电子商务示范企业2家",

        },
        {
          name: "市级电子商务示范基地1个",

        },
        {
          name: "市级电子商务示范企业3家",

        },
        {
          name: "农特产品电商直播基地2个",

        },
      ],

      zhibo: [
        {
          name: "淘宝",
          value: "63145.6",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/tb.png",
        },
        {
          name: "抖音",
          value: "39952",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/dy.png",
        },
      ],
      fensi: [
        { name: "粉丝", value: "1256" },
        { name: "新用户", value: "98%" },
      ],
      zhiboRenqi: [
        { name: "男", value: "3000" },
        { name: "女", value: "3450" },
      ],
      leftRightData2: [
        {
          name: "供应商",
          value: "300",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/gys.png",
        },
        {
          name: "投标单位",
          value: "345",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/tb(1).png",
        },
        {
          name: "中标单位",
          value: "45",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/zb.png",
        },
      ],

      leftRightData1: [
        {
          name: "供应",
          value: "2021",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/cl.png",
          txt1: "电商交易总额39.43亿元",
          txt2: "电商企业341家",
          txt3: "从业人数962人",
        },
        {
          name: "求购",
          value: "2022",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/sc.png",
          txt1: "电商交易总额41.64亿元",
          txt2: "电商企业374家",
          txt3: "从业人数1078人",
        },
        {
          name: "求购",
          value: "2023",
          icon: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/sc.png",
          txt1: "电商交易总额43.7亿元",
          txt2: "电商企业413家",
          txt3: "从业人数1210人",
        },
      ],
      zhiboData1: [
        {
          name: "增长8.9%",
          icon: require("../assets/img/xaiofei/data/sx1.png"),
          txt1: "交易总额",
          txt2: "15.8",
          txt3: "亿",
        },
        {
          name: "增长31.4%",
          icon: require("../assets/img/xaiofei/data/sx2.png"),
          txt1: "企业数量",
          txt2: "67",
          txt3: "家",
        },
        {
          name: "增长15.3%",
          icon: require("../assets/img/xaiofei/data/sx3.png"),
          txt1: "从业人数",
          txt2: "481",
          txt3: "人",
        },
      ],


      zhiboData2: [
        {
          name: "增长2.4%",
          icon: require("../assets/img/xaiofei/data/sx1.png"),
          txt1: "交易总额",
          txt2: "27.9",
          txt3: "亿",
        },
        {
          name: "增长7.1%",
          icon: require("../assets/img/xaiofei/data/sx2.png"),
          txt1: "企业数量",
          txt2: "346",
          txt3: "家",
        },
        {
          name: "增长10.3%%",
          icon: require("../assets/img/xaiofei/data/sx3.png"),
          txt1: "从业人数",
          txt2: "729",
          txt3: "人",
        },
      ],
      zhibojianData: [
        {
          name: "一、太阳仓直播间",
        },
        {
          name: "二、状元红直播间",
        },
        {
          name: "三、巨型一号直播间",
        },
        {
          name: "四、古蔡铁锅直播间",
        },
        {
          name: "五、百汇通直播间",
        },
        {
          name: "六、茵速体育电商画面",
        },
        {
          name: "七、三和饲料电商画面",
        },
        {
          name: "八、空港物流园",
        },
        {
          name: "九、状元红检测中心",
        },
      ],
      center_data: [
        {
          name: "一、太阳仓直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-1.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "二、状元红直播间",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-2.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/2.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AY8102748/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AY8102748"
        },
        {
          name: "三、巨型一号直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-3.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/3.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "四、古蔡铁锅直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-4.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/4.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "五、百汇通直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-5.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/5.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "六、茵速体育电商画面",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-6.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/6.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538196/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538196"
        },
        {
          name: "七、张坤猪蹄直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-7.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/7.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "八、囧驿自热小火锅直播间",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/image/3-8.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/8.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "九、状元红检测中心",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/3-9.gif",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_3_9/jczx9.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AY8102738/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AY8102738"
        },
      ],

      right_left_data1: [
        {
          id: 1,
          name: "乔师兄",
          fensi: 562.3,
          header: require("../assets/img/xaiofei/data1/zhubo/1.jpg"),
        },
        {
          id: 1,
          name: "山村姐弟",
          fensi: 482.3,
          header: require("../assets/img/xaiofei/data1/zhubo/11.jpg"),
        },
        {
          id: 2,
          name: "王铮铭0396",
          fensi: 189.4,
          header: require("../assets/img/xaiofei/data1/zhubo/2.jpg"),
        },
        {
          id: 3,
          name: "一只小哥哥",
          fensi: 155.3,
          header: require("../assets/img/xaiofei/data1/zhubo/3.jpg"),
        },
        {
          id: 5,
          name: "冬火火",
          fensi: 31.2,
          header: require("../assets/img/xaiofei/data1/zhubo/5.jpg"),
        },
        {
          id: 6,
          name: "仁义哥传媒",
          fensi: 28.5,
          header: require("../assets/img/xaiofei/data1/zhubo/6.jpg"),
        },
        {
          id: 7,
          name: "郏卫军",
          fensi: 27.3,
          header: require("../assets/img/xaiofei/data1/zhubo/7.jpg"),
        },
        {
          id: 8,
          name: "大姐姐",
          fensi: 29.3,
          header: require("../assets/img/xaiofei/data1/zhubo/8.jpg"),
        },
        {
          id: 9,
          name: "天伦华叔",
          fensi: 24.3,
          header: require("../assets/img/xaiofei/data1/zhubo/9.jpg"),
        },
        {
          id: 10,
          name: "乡村小嫂子",
          fensi: 17.8,
          header: require("../assets/img/xaiofei/data1/zhubo/10.jpg"),
        },
        // {
        //   id: 4,
        //   name: "李美丽",
        //   fensi: 15.3,
        //   header: require("../assets/img/xaiofei/data1/zhubo/4.jpg"),
        // },
      ],
      right_l_data2: [
        { name: "大纲粮仓", value: 10, unit: "" },
        { name: "一只小哥哥", value: 20, unit: "" },
        { name: "乔师兄", value: 66, unit: "" },
        { name: "郏卫军", value: 10, unit: "" },
      ],
      // [{ name: '一只小哥哥', value: 20 ,unit:""}],
      // [{ name: '乔师兄', value: 66 ,unit:""}],
      // [{ name: '郏卫军', value: 10 ,unit:""}],

      rightData1: [
        { name: "产品1", value: 896756 },
        { name: "产品2", value: 96756 },
        { name: "产品3", value: 16756 },
      ],
      startVal: 0, //数字结束
      rightData2: [
        [
          { name: "网销下单", value: "58926" },
          { name: "可用率", value: "100%" },
        ],
        [
          { name: "网销退单", value: "8926" },
          { name: "可用率", value: "100%" },
        ],
      ],
      rightData3: [
        { name: "近三年平均增长速度", value: "1.2%" },
        { name: "电商消费系数", value: "80" },
      ],
      popShow: false,
      curVideoIndex: 0,
      rightImg:[{ imageUrl: require('../assets/img/xaiofei/data/dt2.png')},
        { imageUrl:  require('../assets/img/xaiofei/data/dt1.png') },
      ],
      AccessToken:""
    });
    onMounted(() => {
      // init();
      // animate();
      state.AccessToken = localStorage.getItem('AccessToken')
    });
    onUnmounted(() => {
      // 清理资源
      // renderer.dispose();
    });
    onBeforeUnmount(() => {
      clearInterval(timer.value);
    });
    // 弹出视频
    function videoClick(index1,types) {
      console.log(index1);
      state.popShow = true;
      state.curVideoIndex = index1;
      state.videotype = types;
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function close() {
      state.isShow = !state.isShow;
    }
    // function init() {
    //   // 初始化渲染器
    //   renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    //   renderer.setClearColor(0x000000, 0); // 设置背景清除颜色为黑色但不透明度为0
    //   //renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true // 这允许renderer有透明通道 })
    //   renderer.setSize(
    //     canvasContainer.value.clientWidth,
    //     canvasContainer.value.clientHeight
    //   );
    //   canvasContainer.value.appendChild(renderer.domElement);
    //
    //   // 初始化场景
    //   scene = new THREE.Scene();
    //
    //   // 初始化相机
    //   camera = new THREE.PerspectiveCamera(
    //     105,
    //     canvasContainer.value.clientWidth / canvasContainer.value.clientHeight,
    //     1,
    //     1000
    //   );
    //   // camera.position.z = 3;
    //   camera.position.set(0, 0, 1.3); //设置相机位置
    //   // camera.position.set(0, 0, 200); //设置相机位置
    //   camera.lookAt(scene.position); //设置相机方向(指向的场景对象)
    //
    //   // 图片纹理加载器
    //   textureLoader = new THREE.TextureLoader();
    //   textureLoader.load(waterimg, (texture) => {
    //     // 创建一个平面几何体
    //     const geometry = new THREE.PlaneGeometry(2, 2);
    //
    //     // 使用加载好的纹理创建材质
    //     const material = new THREE.MeshBasicMaterial({
    //       map: texture,
    //       transparent: true,
    //     });
    //
    //     // 创建并添加带有纹理的网格到场景中
    //     mesh = new THREE.Mesh(geometry, material);
    //     scene.add(mesh);
    //     var _s = 1.5;
    //     _s += 0.01;
    //     mesh.scale.set(_s, _s, _s);
    //
    //     renderer.render(scene, camera); //执行渲染操作
    //     // requestAnimationFrame(render) //请求再次执行渲染函数render，渲染下一帧
    //   });
    // }
    // function animate() {
    //   requestAnimationFrame(animate);
    //
    //   if (mesh) {
    //     // 每帧增加旋转角度
    //     // mesh.rotation.x += rotationSpeedX;
    //     // mesh.rotation.y += rotationSpeedY;
    //     // mesh.rotation.y += Math.PI;
    //     mesh.rotation.z += rotationSpeedZ;
    //
    //     // 如果需要限制旋转范围，可以使用下面的方法：
    //     // mesh.rotation.x = mesh.rotation.x % (1 * Math.PI);
    //     // mesh.rotation.y = mesh.rotation.y % (1 * Math.PI);
    //     // mesh.rotation.z = mesh.rotation.z % (1 * Math.PI);
    //   }
    //
    //   renderer.render(scene, camera);
    // }
    return {
      ...toRefs(state),
      close,
      clickReturn,
      // canvasContainer,
      videoClick,
      popHiddlen,
    };
  },
  components: {
    Tit,
    leftPie,
    nyTit1,
    leftLine,
    rightRBar,
    countTo,
    LeftLBar,
    leftBar,
    centerRadar,
    zhuboItem,
    footer1,
    popBg,
    LiveStats,
    LiveTrend,
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
a {
  color: #fff;
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

// 修改右侧产品带货列表列表样式
::v-deep .dv-scroll-board .rows .row-item,
::v-deep .dv-scroll-board .header {
  font-size: 24px;
}
.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;
  .content {
    position: absolute;
    top: 190px;
    left: 0;
    width: 100%;

    height: calc(100% - 190px);
    display: flex;
    position: relative;
    padding: 20px 80px 48px;
    box-sizing: border-box;
    .navBox {
      position: absolute;
      left: 0;
      top: 0;
      width: 320px;
      height: 100%;
      z-index: 999;
      .navLeft {
        width: 320px;
        height: 100%;
        padding-right: 120px;
        display: flex;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png")
          no-repeat top center;
        background-size: 100% 100%;
        position: relative;
        transition: all 1s ease-out;
        .leftLeft {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          transition: all 1s ease-out;
          .btn {
            width: 147px;
            height: 53px;
            text-align: center;
            line-height: 53px;
            margin: 30px 0 0 0;
            font-size: 16px;
            cursor: pointer;
            transition: all 1s ease-out;
            animation: bianda 1s linear infinite;
            position: relative;
            span {
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .btn1,
          .btn:hover {
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/xz.png")
              no-repeat top center;
            color: #dbd600;
          }
          .btn2 {
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/wxz.png")
              no-repeat top center;
            color: #9fefee;
          }
          .btn1:hover {
            position: relative;
            animation-play-state: paused;
            margin-bottom: 30px;
          }
        }
        .jiantou {
          width: 76px;
          height: 127px;
          position: absolute;
          right: 90px;
          animation: jiantou 1s linear infinite;
          cursor: pointer;
        }
        .jiantou1 {
          transform: rotate(180deg);
        }
      }
      .left1 {
        width: 160px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png")
          no-repeat center right;
        transition: all 1s ease-out;
      }
      .leftLeft1 {
        width: 0;
        overflow: hidden;
        .btn {
          width: 0;
        }
      }
    }

    .leftBox {
      height: 100%;
      padding: 12px 12px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      position: relative;
      overflow: hidden;
      // border: 1px solid;
    }
    .rightBox {
      height: 100%;
      padding: 12px 12px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;
      overflow: hidden;
      // border: 1px solid;
    }
    // 左侧
    .leftBox {
      width: 1730px;
      .left_left {
        display: flex;
        flex-direction: column;
        background: linear-gradient(
          to right,
          rgba(10, 39, 66, 0),
          rgba(10, 39, 66, 1)
        );
        .titleBg {
          font-size: 40px;
          // text-shadow: 0 0 1px rgba(75,180,229,.5);
          background: linear-gradient(
            to top,
            #fff 25%,
            #fff 55%,
            rgba(14, 197, 236, 0.8) 95%
          );
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-style: italic;
          letter-spacing: 2px;
          font-weight: bold;
          padding-right: 15px;
          padding-left: 15px;
          margin-left: 15px;
        }
      }
      // 左-左
      .left_left {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-bottom: 30px;
        box-sizing: border-box;
        // 直播平台
        .left_l_Box1 {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .boxContent1 {
            width: 100%;
            flex: 1;
            // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/fkdz.png") no-repeat top right;
            display: flex;
            margin-top: 10px;
            .boxContent1Left {
              flex: 1;
              line-height: 60px;
              display: flex;

              justify-content: center;
              padding-left: 20px;
              .boxContent1LeftItem {
                text-align: left;
                .name {
                  font-size: 30px;
                  color: #b1eded;
                  img {
                    width: 33px;
                    height: 26px;
                    margin-right: 20px;
                  }
                }
                .value {
                  font-size: 40px;
                  color: #ffffff;
                  font-weight: bold;
                  padding-left: 20px;
                }
              }
              .boxContent1LeftItem:nth-child(1) {
                margin-bottom: 40px;
              }
            }
            // .boxContent1Right {
            //   width: 220px;
            //   height: 232px;
            //   margin-left: 2%;
            //   margin-top: 23%;
            // }
          }
          .left_r_contentB {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 870px;
            height: 100%;
            .left_r_contentB_top{
              width: 100%;
              height: 340px;
              //border: 1px solid #d0deee;
              display: flex;
              flex-direction: column;
              .contentB_top_nr{
                width: 100%;
                height: 33.3%;
                display: flex;
                justify-content: left;
                align-items: center;

                img{
                  width: 251px;
                  height:112px ;
                }
                span{
                  font-size: 30px;
                  color: #fff;
                  margin-left: -145px;
                  font-weight: bold;
                  line-height: 18px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  background: radial-gradient(0deg, #4CBAFF 0%, #FFFFFF 100%);

                }



              }


            }
            .left_r_contentB_down{
              width: 100%;
              flex: 1;
              //border: 1px solid #d0deee;
              display: flex;
              justify-content: center;
              align-items: center;
              .contentB_down_img{
                width: 105px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                img{
                  width: 105px;
                  height: 142px;

                }
                span{
                  width: 100%;
                  display: block;
                  font-size: 30px;
                  color: #fff;

                  font-weight: bold;

                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  margin-top: -60px;
                  text-align: center;


                }

              }
              .ontentB_down_nr{
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                span{
                  width: 100%;
                  display: block;
                  font-size: 30px;
                  color: #fff;

                  font-weight: bold;

                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  background: radial-gradient(0deg, #4CBAFF 0%, #FFFFFF 100%);
                  margin-left: 50px;

                }


              }


            }

          }
          .left_top_youbian {
            flex: 1;
            height: 100%;
          }
        }

        .leftcontent1BItem {
          width: 100%;
          height: 170px;
          margin: 5px;
          box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
          border-radius: 5px;
          flex: 1;
          display: flex;
          // justify-content: center;
          align-items: center;
          animation: leftJx 1s linear infinite;
          background: #05394d;
          img {
            width: 89px;
            height: 96px;
            margin-left: 20px;
          }
          .itemRight {
            display: flex;
            flex-direction: column;
            font-size: 36px;
            text-align: left;
            span {
              display: block;
              line-height: 50px;
              font-size: 30px;
              margin-left: 20px;
            }
            span:last-child i {
              color: #14955c;
              margin-right: 5px;
              font-size: 36px;
              font-style: normal;
            }
          }
          .right_txt {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;

            span {
              flex: 1;
              font-size: 30px;
              justify-content: center;
              text-align: left;
              padding: 0 20px 0 30px;
              // align-items: center;
            }
          }
        }
      }
      // 左-右
      .left_right {
        width: 100%;
        display: flex;
        flex: 1;
        background: linear-gradient(
          to right,
          rgba(10, 39, 66, 0),
          rgba(10, 39, 66, 1)
        );

        // flex-direction: column;
        padding-bottom: 40px;
        .left_r_Box1 {
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-bottom: 50px;
          margin-top: 10px;
          margin-left: 20px;
          .left_r_contentA {
            width: 75%;
            flex: 1;
            display: flex;
            .zhu_zhuang_tu {
              flex: 1;
              height: 100%;
              padding: 0 15px;
              // border: #056f4e 1px solid;
              position: relative;
              span {
                width: 100%;
                height: 50px;
                font-size: 24px;
                text-align: center;
                justify-content: center;
                position: absolute;
                left: 0;
                display: block;
              }

              .sapn_top {
                top: 18%;
              }
              .sapn_down {
                bottom: 18%;
              }
              .sapn_down1 {
                bottom: 12%;
              }

              .sapn_down2 {
                bottom: 10%;
              }

              img {
                bottom: 30%;
                width: auto;
                height: auto;
                position: absolute;
              }
            }
            .zhu_zhuang_tu:first-child {
              span:first-child {
                top: 34%;
              }
            }
          }
        }
        .left_r_Box2 {
          flex: 1;
          height: 100%;

          //background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/fkdz.png")
          //  no-repeat 50% 80%;
          display: flex;
          margin-top: 10px;
         .boxContent1Rights{
           width: 100%;
           height: 100%;
           display: flex;
           flex-direction: column;
           .boxContent1Rights_nr{
             width: 100%;
             height: 18%;
              margin: 1% 0;
             display: flex;
             justify-content: center;
             align-items: center;
             img{
               width: 292px;
               height: 70px;

             }
             span{
               width: 100%;
               display: block;
               font-size: 30px;
               color: #fff;
               font-weight: bold;
               text-align: left;
               font-style: normal;
               text-transform: none;
               margin-left: -197px;

             }



           }



          }

          //.boxContent1Right {
          //  width: 240px;
          //  height: 232px;
          //  margin-left: 30%;
          //  margin-top: 25%;
          //}
        }
      }
      .left_center {
        margin: 0 40px;
      }
      .leftBox1 {
        flex: 1;
        display: flex;
        flex-direction: column;
        cursor: pointer;
      }
    }

    .center {
      flex: 1;
      height: 100%;
      position: relative;
      margin: 0 20px;
      display: flex;
      // flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
      .center_left{
        width: 790px;
        height: 100%;
        display: grid;
        grid-template-rows: 122px 280px 1fr 1fr;
        grid-template-columns: 1fr;
        gap: 15px;
        padding: 30px 15px 15px;
        box-sizing: border-box;
        align-items: center;
        .grid-item{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-width: 0;
          font-size: 28px;
          color: #fff;
        }
        .grid-item-1{
          background: url("../assets/img/zb.png") no-repeat center center;
          background-size: 100% 100%;
          height: 132px;
          font-size: 40px;
          color: #ffffff;
          font-weight: bold;
        }

        .grid-item-3,
        .grid-item-4{
          height: 100%;
          min-height: 290px;
          align-items: stretch;
          justify-content: stretch;
          overflow: hidden;
        }

        .grid-item-4{
          color: #fff;
        }
      }
      .center_mi{
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .center_mi_top{
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .center_mi_down{
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }



      }
      .center_right{
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .center_right_top,
        .center_right_down{
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .img {
        height: 100%;
        background-size: 100% 100% !important;
        padding: 43px 36px;
        box-sizing: border-box;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .jian_kong_fc {
          width: 95%;
          height: 90px;
          line-height: 90px;
          background: rgba(7, 72, 112, .8);
          position: absolute;
          top: 0.5%;
          left:2.5%;
          font-size: 30px;
          z-index: 999;
        }
      }
      .img1 {
        width: 100%;
        height: 88%;
        margin-top:30px;
        margin-left: 40px;
        margin-right: 20px;
        background: url("../assets/img/sanchan1/zk.png") no-repeat;
        background-size: 100% 100%;
      }


    }
    // 右
    .rightBox {
      width: 1800px;
      display: flex;
      overflow: hidden;
      background: linear-gradient(to right, rgba(10, 37, 60, 0), #0a253c);
      .right_left {
        width: 800px;
        height: 100%;
        display: flex;
        flex-direction: column;
        display: flex;
        flex-direction: column;
      }
      .right_right {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        display: flex;
        flex-direction: column;
        .center_videoBox{
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          padding-top: 50px;
          padding-right: 20px;
          .center_video_item{
            width: 33%;
            img{
              width: 90%;
              height: 200px;
            }
          }
        }
        .leftBox2 {
          height: 48%;

          display: flex;
          flex-direction: column;
          // padding: 0 20px;
          .imgBox {
            display: flex;
            justify-content: center;
            height: 189px;
            img {
              width: 238px;
              height: 189px;
              margin: 30px 50px;
            }
          }
        }
      }


      .leftBox3 {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        .leftBox1 {
          width: 100%;
          height: 140px;
          display: flex;
          flex-direction: column;
          .leftContent1 {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;
            padding: 0 40px;
            margin-top: 30px;
            .leftContent1_item {
              display: flex;
              flex-direction: column;
              margin: 0 10px;
              .leftContent1_item_name {
                font-size: 22px;
                color: #d0deee;
                line-height: 26px;
              }
              .leftContent1_item_value {
                font-size: 32px;
                color: #00ffea;
                margin-top: 4px;
                i {
                  font-size: 22px;
                  color: #d0deee;
                  margin-left: 8px;
                }
              }
            }
          }
        }
        .leftBox2 {
          width: 100%;
          height: 300px;
          display: flex;
          flex-direction: column;
          .title1 {
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: url("../assets/img/sanchan1/zb.png") no-repeat left bottom;
            color: #d2e2f2;
            font-size: 30px;
            text-align: left;
            margin-left: 40px;
            padding-left: 20px;
            box-sizing: border-box;
            font-weight: bold;
          }
          .echartBox {
            width: 100%;
            flex: 1;
          }
        }
        .leftBox33{
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: -30px;
          .leftBox33_nr{
            flex: 1;
            height: 50px;
            line-height: 50px;
            text-align: left;
            text-indent: 2em;
            background: url("../assets/img/xaiofei/data/new/dd.png") no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-size:24px ;
          }
        }
      }
      .leftContent {
        width: 98%;
        flex: 1;
        margin-top: 30px;
        margin-bottom: 55px;
      }
      .rightBox1 {
        height: 700px;
        display: flex;
        flex-direction: column;
        .rightcontent2 {
          width: 100%;
          flex: 1;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .rightcontent1A {
          width: 100%;
          display: flex;
          padding-top: 10px;
          height: 300px;
          box-sizing: border-box;
          .rightcontent1AItem {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
            font-size: 40px;
            .fontNum {
              font-size: 50px;
              color: #fff;
              font-weight: bold;
              animation: bianda 1s linear infinite;
              opacity: 0.8;
            }
            img {
              width: 222px;
              height: 106px;
              margin-top: -15px;
              animation: guangying 1s linear infinite;
              transform: scale(2);
            }
          }
        }
        .rightcontent1B {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          .titleB {
            position: relative;
            text-align: left;
            padding-left: 10px;
            display: flex;
            height: 50px;
            line-height: 50px;
            font-size: 50px;
            margin-bottom: 30px;
            span {
              display: block;
              width: 50%;
              height: 1px;
              background: linear-gradient(
                to right,
                #034033,
                rgba(3, 64, 51, 0) 95%
              );
              position: relative;
              margin-top: 10px;
              margin-left: 30px;
            }
            span::before {
              content: "";
              position: absolute;
              left: 0;
              top: -3px;
              width: 6px;
              height: 6px;
              background: #034033;
              border-radius: 50%;
            }
          }
          .titleB::before {
            content: "";
            position: absolute;
            left: 0;
            top: 4px;
            width: 2px;
            height: 12px;
            background: #056f4e;
          }
          .rightcontent1BList {
            flex: 1;
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            .rightcontent1BItem {
              flex: 1;
              height: 100%;
              border: 1px solid #031821;
              padding: 5px;
              margin: 0 2%;
              .rightcontent1BItem1 {
                width: 100%;
                height: 100%;
                border: 1px solid #0b564f;
                box-shadow: inset 0 0 5px 1px rgba(55, 199, 219, 0.5);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                padding: 10px 0;
                box-sizing: border-box;
                .rightcontent1BItem2 {
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding: 0 20px;
                  box-sizing: border-box;
                  line-height: 60px;
                  span {
                    display: block;
                    width: 100%;
                    text-align: left;
                  }
                  span:first-child {
                    font-size: 40px;
                  }
                  span:last-child {
                    font-weight: bold;
                    font-size: 40px;
                    color: #057551;
                    letter-spacing: 2px;
                  }
                }
              }
            }
          }
        }
      }
      .rightBox2 {
        flex: 1;
        display: flex;
        //flex-direction: column;
        align-items: center;
        margin: 50px 0 15px;
        .rightBox2_title_list {
          width: 100%;
          height: 140px;
          display: flex;
          flex-direction: column;
          .title_list_left {
            width: 40%;
            flex: 1;
            display: flex;
            margin-left: 60%;
            align-items: center;
            img {
              width: 26px;
              height: 25px;
            }
            span {
              font-size: 26px;
              color: #fff;
              display: flex;
              text-align: left;
            }
          }
          .title_list_right {
            width: 40%;
            flex: 1;
            display: flex;
            margin-left: 60%;
            align-items: center;
            img {
              width: 26px;
              height: 25px;
            }
            span {
              font-size: 26px;
              color: #fff;
              display: flex;
              text-align: left;
            }
          }
        }
        .rightcontent2 {
          flex: 1;
        }
        ::v-deep .el-carousel{
          width: 100%;
          height: 100%;

          img{
            width: 732px;
            height: 509px;
          }
        }
      ::v-deep .el-carousel__container{
        height: 509px;
      }
        ::v-deep .el-carousel__button{
          width: 60px;
          height: 10px;
        }
      }
      .rightBox3 {
        display: flex;
        flex-direction: column;
        flex: 1;
        .rightcontent3A {
          height: 74px;
          width: 100%;
          display: flex;
          .rightcontent3ALeft {
            width: 74px;
            height: 74px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data/wq.png")
              no-repeat top center;
            position: relative;
            img {
              position: absolute;
              top: 5px;
              left: 5px;
              width: 64px;
              height: 64px;
              animation: rightCircle 3s linear infinite;
            }
            .circleContent {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size: 16px;
              span {
                display: block;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
          .rightcontent3ARight {
            height: 100%;
            flex: 1;
            position: relative;
            display: flex;
            justify-content: center;
            .rightcontent3ARightItrem {
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin: 0 20px;
              font-size: 14px;
              span {
                display: block;
              }
              span:last-child {
                font-size: 18px;
                color: #056246;
                margin-top: 3px;
                font-weight: bold;
              }
            }
            .line {
              width: 100%;
              height: 2px;
              background: linear-gradient(
                to right,
                #034033,
                rgba(3, 64, 51, 0) 95%
              );
              position: absolute;
              left: -18px;
            }
            .line1 {
              top: 5px;
            }
            .line2 {
              bottom: 5px;
            }
          }
        }
        .rightcontent3B {
          width: 100%;
          flex: 1;
        }
      }
    }
    // 标题
    .title {
      width: 795px;
      height: 80px;
      // line-height: 20px;
      text-align: left;
      // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/xbt.png") no-repeat left bottom ;
      background: url("../assets/img/xaiofei/data1/xbt.png") no-repeat left
        bottom;
      // background-size: 100% 100%!important;
      padding-left: 30px;
      box-sizing: border-box;
      animation: title 3s linear infinite;
      display: flex;
      justify-content: space-between;
      padding: 0 5px;
      .titleBg {
        font-size: 48px;
        // text-shadow: 0 0 1px rgba(75,180,229,.5);
        background: linear-gradient(
          to top,
          #fff 25%,
          #fff 55%,
          rgba(14, 197, 236, 0.8) 95%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        letter-spacing: 2px;
        font-weight: bold;
        padding-right: 15px;
        padding-left: 15px;
        margin-left: 15px;
      }
      img {
        height: 12px;
        margin-right: 20px;
        margin-top: 5px;
        transform: scale(2);
      }
    }

    // 左边下部分的导航
    .titledow {
      width: 95%;
      height: 80px;
      // line-height: 20px;
      text-align: left;
      // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/xbt.png") no-repeat left bottom ;
      background: url("../assets/img/xaiofei/data1/xbt.png") no-repeat left
        bottom;
      // background-size: 100% 100%!important;
      padding-left: 30px;
      box-sizing: border-box;
      animation: title 3s linear infinite;
      display: flex;
      justify-content: space-between;
      .titleBg {
        font-size: 48px;
        // text-shadow: 0 0 1px rgba(75,180,229,.5);
        background: linear-gradient(
          to top,
          #fff 25%,
          #fff 55%,
          rgba(14, 197, 236, 0.8) 95%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        letter-spacing: 2px;
        font-weight: bold;
        padding-right: 15px;
        padding-left: 15px;
      }
      img {
        height: 12px;
        margin-right: 20px;
        margin-top: 5px;
        transform: scale(2);
      }
    }
  }
}

// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道

@keyframes scale1 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
  75% {
    transform: scale(2);
  }
  78%,
  100% {
    opacity: 0;
  }
}
@keyframes title {
  0% {
    background-position: 0 bottom;
  }
  50% {
    background-position: 10px bottom;
  }
  100% {
    background-position: 0 bottom;
  }
}
@keyframes bianda {
  0% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
  50% {
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {
  0% {
    right: 90px;
  }

  50% {
    right: 95px;
  }
  100% {
    right: 90px;
  }
}

@keyframes guangying {
  0% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }

  50% {
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  100% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}

@keyframes rightCircle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  0% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
  }
}

// 左侧矩形
@keyframes leftJx {
  /*引用动画名称*/
  0% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
  50% {
    box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, 0.5);
  }

  100% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
}
</style>
